export let promotions = {
    'products': [
        { 'promoCode': 'slektogdata',           'productCode': 'OEMBLAV10,OEMBLAV9', 'productListCode': 'PROMOFTV10', 'productPriceListId': 'FFBA16F0-242F-423B-8A85-D1614CD85C15'},
        { 'promoCode': 'historielag',           'productCode': 'OEMBLAV10,OEMBLAV9', 'productListCode': 'PROMOFTV10', 'productPriceListId': 'FFBA16F0-242F-423B-8A85-D1614CD85C15'},
        { 'promoCode': 'versjon10',             'productCode': 'OEMBLAV10' ,         'productListCode': 'FTV10',      'productPriceListId': '134C6E1A-F6D6-4E79-A28E-B91138504C82'},
        { 'promoCode': 'versjon10ogmedlemskap', 'productCode': 'OEMBLAV10,MEMMEM',   'productListCode': 'FTV10NMEM',  'productPriceListId': '53D3AC37-D5AF-4EBE-B72A-FD16DC28F25C'},
        { 'promoCode': 'medlemskap',            'productCode': 'MEMREN' ,            'productListCode': 'MEMREN',     'productPriceListId': '85AEEE9F-1FF1-4535-BA51-E9DBFD010CAC'},
        { 'promoCode': 'versjon9ogmedlemskap',  'productCode': 'OEMBLAV9,C0YRLY01',  'productListCode': 'FTV9NMEM',   'productPriceListId': 'a1d8e25d-3954-48f4-b9c7-49718203e795'},
        { 'promoCode': 'versjon9',              'productCode': 'OEMBLAV9',           'productListCode': 'FTV9MEM',    'productPriceListId': '0dfe194a-cdb9-48d2-82d1-aa2ce947deff'},
    ]
};
/*

    Mapping to the database
    productCode -> DB.Products.Code
    productListCode -> DB.ProductPriceLists.Code
    productPriceListId -> DB.ProductPriceList.ProductPriceListID

*/



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/config/promotions.ts